export default "__VITE_ASSET__CEv2JRBD__"